import { isEmpty, parseInt } from 'lodash'
import React from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { useAuth } from '../AuthProvider';
import roles from '@/constant/roles.config';
import { privateRoutePaths } from '@/routes/private.route.config';
import { buildPath } from '@/utils/common';

function SubHeader(props) {

  let nav = useNavigate();
  const { memberCompanyID, isEndUser, isPreKYCUser, user, } = useAuth();
  const { id } = useParams();

  // console.log("props ============== ", props.clickable);
  // console.log("Layer1 ============== ", props.clickable.layer1);
  // console.log("Layer2 ============== ", props.clickable.layer2);
  // console.log("Layer3 ============== ", props.clickable.layer3);
  const getPrefix = () => {
    if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
    if (user && isEndUser) return roles.END_USER.prefix;
    return roles.SUPER_ADMIN.prefix;
  };

  return (
    <div>
      <div className='sub-header'>
        <div className='d-flex align-items-center'>
          {(isEndUser || isPreKYCUser) && (parseInt(memberCompanyID) === parseInt(id) && (props.layer1) === "Profile" && (props.layer2) === "View") &&
            <Link to={`/${getPrefix()}${buildPath(privateRoutePaths.UPDATE_COMPANY_PROFILE, { id: memberCompanyID })}`}>
              <i class="fa-solid fa-arrow-left-long"></i>
            </Link>
          }
          <h3>{props.pageName}</h3>

        </div>

        <div>
          {/* <span onClick={() => { nav("/members") }}> {props.layer1}</span> */}
          {!isEmpty(props.clickable.layer1) ? <span className='active-breadcrumb' onClick={() => nav(props.clickable.layer1)}>{props.layer1}</span> : <span className='in-active-breadcrumb'>{props.layer1}</span>}
          {!isEmpty(props.layer2) && <i className="fa-solid fa-angle-right mx-2"></i>}

          {!isEmpty(props.clickable.layer2) ? <span className='active-breadcrumb' onClick={() => nav(props.clickable.layer2)}>{props.layer2}</span> : <span className='in-active-breadcrumb'>{props.layer2}</span>}

          {!isEmpty(props.layer3) && <i className="fa-solid fa-angle-right mx-2"></i>}

          {!isEmpty(props.clickable.layer3) ? <span className='active-breadcrumb' onClick={() => nav(props.clickable.layer3)}>{props.layer3}</span> : <span className='in-active-breadcrumb'>{props.layer3}</span>}

        </div>
      </div>

      <h3 className='sub-tital'>{props.subTitle}</h3>


    </div >
  )

}

export default SubHeader
